// App.jsx
import React from "react";
import './index.css'; // or wherever your global styles are
// Core Layout Components
import Hdump from "./components/Hdump";
//import Room from "./components/Room"
import RoomsAndBunks from "./components/Room";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dining from "./components/Dining";
import GalleryPage from "./components/Gallerypage";
import OffersPage from "./components/Offerpage";
import AboutUsPage from "./components/AboutUsPage";
import ContactUs from "./components/ContactUs";
import '@fortawesome/fontawesome-free/css/all.min.css';
import SixBedDormitory from "./components/SixBedDormitory";
import EightBedDormitory from "./components/EightBedDormitory";
import DeluxeTwinRoom from "./components/DeluxeTwinRoom";
import DeluxeKingRoom from "./components/DeluxeKingRoom";




// Optional: Hotel menu panel if needed
// import HotelMenuPanel from "./components/HotelMenuPanel";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Hdump />} />
        <Route path="/BananaBunksKandy/room" element={<RoomsAndBunks />} />
        <Route path="/BananaBunksKandy" element={<Hdump />} />
        <Route path="BananaBunksKandy/dining" element={<Dining />} />
        <Route path="BananaBunksKandy/gallery" element={<GalleryPage />} />
        <Route path="BananaBunksKandy/offers" element={<OffersPage />} />
        <Route path="BananaBunksKandy/aboutus" element={<AboutUsPage />} />

        <Route path="BananaBunksKandy/room/bedin6bed" element={<SixBedDormitory />} />
        <Route path="BananaBunksKandy/room/bedin8bed" element={<EightBedDormitory />} />
        <Route path="BananaBunksKandy/room/twinroom" element={<DeluxeTwinRoom />} />
        <Route path="BananaBunksKandy/room/kingroom" element={<DeluxeKingRoom />} />


        <Route path="BananaBunksKandy/contactus" element={<ContactUs />} />
      </Routes>
    </Router>

  );
};

export default App;
